// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { Query } from 'react-apollo'
import { i18n } from '../index'
import Pagination from '../../common/pagination/Pagination'
import TaskListTable from './TaskListTable'
import { withRouter } from 'react-router-dom'
import { getConnectionNodes, getConnectionTotal } from '../../common/data/helper'
import { ASSIGNMENTS_QUERY, getAssignmentSubjectOptions } from './data'
import Select from '../../common/select/Select'
import get from 'lodash/get'
import RestrictedView from '../auth/RestrictedView'
import withActiveStation from '../station/withActiveStation'
import type { Station } from '../station/stationTypes'
import css from './taskListActive.css'
type Props = {
  history: any
  activeStation: Station
}
type State = {
  pageSize: number
  page: number
  subjectFilter: string | null | undefined
}

@withActiveStation
class TaskListArchive extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      pageSize: 10,
      page: 1,
      subjectFilter: null,
    }
  }

  onPageChange = (page) => {
    this.setState({
      page,
    })
  }
  onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize,
      page: 1,
    })
  }
  onSubjectChange = (subject) => {
    this.setState({
      subjectFilter: subject,
    })
  }

  render() {
    const { page, pageSize, subjectFilter } = this.state
    const { activeStation } = this.props
    return (
      <div className={css.component}>
        <Query
          query={ASSIGNMENTS_QUERY}
          variables={{
            stationId: activeStation.id,
            status: 'Done',
            page: page,
            perPage: pageSize,
            subject: subjectFilter,
          }}
        >
          {({ loading, error, data }) => {
            const items = loading ? [] : getConnectionNodes(get(data, 'assignments', []))
            const total = loading ? 0 : getConnectionTotal(get(data, 'assignments', []))
            const paginationProps = {
              pageSize,
              page,
              total,
              onPageChange: this.onPageChange,
              onPageSizeChange: this.onPageSizeChange,
            }
            return (
              <div className={css.archivedTable}>
                <h3>
                  {i18n.t('taskList.archive.title', {
                    station: activeStation.name,
                  })}
                </h3>
                <div className={css.filters}>
                  <Select
                    className={css.subjectSelect}
                    label={i18n.t('taskList.archive.subjectFilterLabel')}
                    placeholder={i18n.t('taskList.archive.subjectFilterPlaceholder')}
                    value={subjectFilter}
                    onChange={(option) => this.onSubjectChange(option ? option.value : option)}
                    options={getAssignmentSubjectOptions()}
                    isClearable
                  />
                </div>
                <Pagination {...paginationProps} />
                <RestrictedView requiredPermission='edit_tasklist'>
                  {(hasPermission) => <TaskListTable items={items} isLoading={loading} canEdit={hasPermission} />}
                </RestrictedView>
                <Pagination {...paginationProps} hideLegend />
              </div>
            )
          }}
        </Query>
      </div>
    )
  }
}

export default withRouter(TaskListArchive)
